module.exports = __webpack_public_path__ + "img/ic_screens.a597b935.png";